/**
 * Sort plans based on price low to high, but keeping no price highest
 */
export const sortPlans = (plans) =>
  plans.slice().sort((a, b) => (a.price ?? 9999999) - (b.price ?? 9999999));
